import { render, staticRenderFns } from "./videojs_player.vue?vue&type=template&id=8d431d70&scoped=true&"
import script from "./videojs_player.vue?vue&type=script&lang=js&"
export * from "./videojs_player.vue?vue&type=script&lang=js&"
import style0 from "./videojs_player.vue?vue&type=style&index=0&id=8d431d70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d431d70",
  null
  
)

export default component.exports